import React from "react";
import LandingPage from "../components/LandingPage/page/LandingPage"
const Landing = () => <LandingPage />;

export default Landing;
